export default {
    // 基础数据-检查表模板选中显示
    setChecklistClass(state, payload){
        state.isActive = payload;
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js